<script context="module">
    let api = { }
    export const API = api;
</script>

<script>
    import { onMount, createEventDispatcher } from 'svelte'
    
    import axios from 'axios'
    import AlertItem from '../AlertItem.svelte'
    import AlertEditor from '../AlertEditor.svelte'
    import userStore from '../../../stores/user'
    import { background, notifySuccess } from '../../../components/Notifications/AppNotifications.svelte'
    

    export let client = null
    export let model = []
    export let workers = {}
    export let clients = {}
    export let searchQuery = ''

    const dispatch = createEventDispatcher ();
    
    let editorShown     = false,
        editorCreate    = false,
        loadedItem      = null
        


    const listChanged = () => {
        dispatch ('list-changed')
    }

    const onRuleCreate = (event) => {
        // console.log ('onRuleCreate')
        editorCreate = true
        editorShown = true
    }

    const onRuleEdit = (event) => {
        // console.log ('onRuleEdit', event.detail)
        loadedItem = { ...event.detail.bean }
        editorShown = true
        editorCreate = false
    }

    const onRuleDelete = (event) => {
        // console.log ('onRuleDelete', event.detail)
        background (true);
        axios.request ({
            method: 'post',
            url: `/api/alerts/deleteRule/${event.detail.bean.id}`
        }).then (result => {
            // console.log ('delete', JSON.stringify (result.data, null, '  '))
            listChanged ();
            notifySuccess ('Regola alert eliminata.')
        }).catch (e => {
            dispatch ('app-event', { id: 'app-error', error: e });
        });
    }

    const onEditorSave = (event) => {
        let { detail } = event;
        let reqPayload = { ...detail.data }

        // console.log ('payload', JSON.stringify (detail.data, null, '  '))
        // console.log ('bean', loadedItem.id, JSON.stringify (loadedItem, null, '   '))

        if (loadedItem) {
            reqPayload.id = loadedItem.id
        }
        
        background (true);
        axios.request ({
            method: 'post',
            url: `/api/alerts/saveRule/${$userStore.sector.id}`,
            data: reqPayload
        }).then (result => {
            // console.log ('save', JSON.stringify (result.data, null, '  '))
            listChanged ();
            background (false);
            notifySuccess ('Regola alert salvata.')
        }).catch (e => {
            dispatch ('app-event', { id: 'app-error', error: e });
        });

        editorShown = false
        editorCreate = false
        if (loadedItem)
            loadedItem = null
    }

    const onEditorCancel = (event) => {
        editorShown = false
        editorCreate = false
        loadedItem = null
    }

    const getRenderedList = list => {
        let result = [],
            latestClient = null;
        list.forEach(it => {
            const { name } = it.client;
            if (name !== latestClient) {
                result.push({
                    id: 'client-name',
                    first: latestClient === null,
                    name
                });
                latestClient = name;
            }
            result.push(it);
        });
        return result;
    }

    onMount (() => {
        api.create = onRuleCreate;
    })

    $: filteredModel = searchQuery.trim() !== '' ? model.filter(it => it.client.name.toLowerCase().includes(searchQuery.toLowerCase())) : model;
    $: renderedList = client ? filteredModel : getRenderedList(filteredModel);
</script>


<div class="avoid-selection">
    {#if model}
        {#each renderedList as data}
            {#if data.id === 'client-name'}
                <div class="font-bold mb-1" class:mt-3={!data.first}>{data.name}</div>
            {:else}
                <AlertItem {data} on:edit={onRuleEdit} on:delete={onRuleDelete} />
            {/if}
        {:else}
            <div>Nessun risultato trovato</div>
        {/each}
    {/if}
</div>

{#if editorShown}
    <AlertEditor {client} data={loadedItem} create={editorCreate} on:save={onEditorSave} on:cancel={onEditorCancel} on:app-event />
{/if}


<style>
    
</style>